"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentsV1 = void 0;
var location_1 = require("./location");
var tracking_1 = require("./tracking");
var item_1 = require("./item");
var production_1 = require("./production");
var ComponentsV1 = /** @class */ (function () {
    function ComponentsV1(data) {
        this.tracking = new tracking_1.TrackingV1(data.tracking);
        this.location = new location_1.LocationV1(data.location);
        this.item = new item_1.ItemV1(data.item);
        this.production = new production_1.ProductionV1(data.production);
        this.partner = data.partner;
        this.expectedRoute = data.expectedRoute;
    }
    ComponentsV1.prototype.getLocation = function () {
        return this.location;
    };
    ComponentsV1.prototype.getTracking = function () {
        return this.tracking;
    };
    ComponentsV1.prototype.getItem = function () {
        return this.item;
    };
    ComponentsV1.prototype.getProduction = function () {
        return this.production;
    };
    ComponentsV1.prototype.getPartner = function () {
        return this.partner;
    };
    ComponentsV1.prototype.getExpectedRoute = function () {
        return this.expectedRoute;
    };
    return ComponentsV1;
}());
exports.ComponentsV1 = ComponentsV1;
//# sourceMappingURL=component.js.map